import T from 'core/i18n/t'
import { Component, Fragment } from 'react'
import Topbar from '../topbar/topbar-container'
import FrequenciesFilterProvider from './context/Provider'
import RfTuningDvbcHistory from './dvbc/rf-tuning-dvbc-history-container'
import RfTuningScanComponent from './scan'
import RfTuningFullFrequencyComponent from './status'

import { isEmpty } from 'core/utils/general-utils'
import FrequencyFilters from './components/FrequencyFilters'
import './index.scss'
import { RfTuningLimitValues } from './status/redux/types'

interface RfTuningComponentProps {
  changeTab: any
  currentTab: string
  currentFrequencyTab: string
  hhid: string
  id: string
  frequencyLimits?: Array<RfTuningLimitValues>
}

export default class RfTuningComponent extends Component<RfTuningComponentProps> {
  toggleTab(tab: string) {
    const { changeTab } = this.props
    changeTab(tab)
  }

  render() {
    const { currentTab, id, hhid, frequencyLimits } = this.props

    return (
      <FrequenciesFilterProvider>
        <Fragment>
          <div className="columns width-full">
            <div className="column">
              <Topbar id={id}></Topbar>
            </div>
          </div>

          <div className="tile is-parent is-vertical has-margin-bottom-lg">
            <div className="tile is-parent is-paddingless is-horizontal">
              <div className="frequencies-container container is-fluid has-margin-none">
                <FrequencyFilters frequencyLimits={!isEmpty(frequencyLimits) ? frequencyLimits : []}/>
                <div className="tabs is-medium">
                  <ul>
                    <li className={currentTab === 'full' ? 'is-active' : ''}>
                      <button className="button-link" onClick={() => this.toggleTab('full')}>
                        <T>rf_tuning.tab_full_frequency_scan</T>
                      </button>
                    </li>
                    <li className={currentTab === 'custom' ? 'is-active' : ''}>
                      <button className="button-link" onClick={() => this.toggleTab('custom')}>
                        <T>rf_tuning.tab_custom_frequency_scan</T>
                      </button>
                    </li>
                    <li className={currentTab === 'dvbc' ? 'is-active' : ''}>
                      <button className="button-link" onClick={() => this.toggleTab('dvbc')}>
                        <T>rf_tuning.tab_dvbc_monitoring</T>
                      </button>
                    </li>
                  </ul>
                </div>
                {currentTab === 'full' && <RfTuningFullFrequencyComponent id={id} />}
                {currentTab === 'custom' && <RfTuningScanComponent id={id} hhid={hhid} />}
                {currentTab === 'dvbc' && <RfTuningDvbcHistory deviceId={id} />}
              </div>
            </div>
          </div>
        </Fragment>
      </FrequenciesFilterProvider>
    )
  }
}
